import _ from 'lodash';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Modal, ModalBody } from 'reactstrap';
import { isAdmin, isSudo } from '../../helpers/permissions.helper';
import { pedidosService } from '../../services/pedidos.service';
import './CadastroPedidoModal.css';

type State = {
  isModalVisible: any,
};

class CadastroPedidoModal extends PureComponent<{}, State> {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
      produtos: [],
      quantidadeTotal: null,
      consultandoReservas: false,
      reservasProduto: [],
      reservasCarregadas: false,
      mostrarReservas: false,
      produtoReservaChave: null,
      detalhesReservas: {},
      quantidadesEdicao: {},
      salvandoReservas: {},
    };
  }

  componentDidUpdate(prevProps) {
    const chaveAnterior = this.getProdutoReservaChave(prevProps);
    const chaveAtual = this.getProdutoReservaChave(this.props);
    const reabriuModal =
      !prevProps.isModalVisible && this.props.isModalVisible === true;

    if (chaveAnterior !== chaveAtual || reabriuModal) {
      this.setState({
        consultandoReservas: false,
        reservasProduto: [],
        reservasCarregadas: false,
        mostrarReservas: false,
        produtoReservaChave: chaveAtual,
        detalhesReservas: {},
        quantidadesEdicao: {},
        salvandoReservas: {},
      });
    }
  }

  getUnidadeMedidaProduto = () => {
    const produto = this.props.produto || {};

    let unidade =
      produto.unidadeMedida ||
      produto.unidade ||
      produto.codigoUnidade ||
      produto.unidadeProduto ||
      null;

    if (!unidade && produto.label) {
      const match = String(produto.label).match(/\(([^)]+)\)\s*$/);
      if (match && match[1]) {
        unidade = match[1];
      }
    }

    if (!unidade && produto.descricao) {
      const match = String(produto.descricao).match(/\(([^)]+)\)\s*$/);
      if (match && match[1]) {
        unidade = match[1];
      }
    }

    return unidade
      ? String(unidade)
          .trim()
          .toUpperCase()
      : '';
  };

  isUnidadePeso = () => {
    const unidade = this.getUnidadeMedidaProduto();

    return ['KG'].indexOf(unidade) >= 0;
  };

  getProdutoReservaChave = (props) => {
    const produto = (props && props.produto) || {};
    return `${produto.codigoProduto || ''}|${produto.codigoOmni || ''}`;
  };

  podeAjustarItemIntegrado = () => {
    return this.props.podeAjustarItemIntegrado === true || isSudo();
  };

  podeConsultarReservas = (totalReservado) => {
    const produto = this.props.produto || {};
    return (
      (isAdmin() || this.podeAjustarItemIntegrado()) &&
      totalReservado > 0 &&
      (produto.codigoProduto || produto.codigoOmni)
    );
  };

  toggleReservasProduto = () => {
    if (this.state.mostrarReservas) {
      this.setState({ mostrarReservas: false });
      return;
    }

    if (this.state.reservasCarregadas) {
      this.setState({ mostrarReservas: true });
      return;
    }

    this.carregarReservasProduto();
  };

  carregarReservasProduto = () => {
    const produto = this.props.produto || {};

    if (!produto.codigoProduto && !produto.codigoOmni) {
      return;
    }

    this.setState({ consultandoReservas: true });

    pedidosService.consultarReservasProduto(produto, this.props.cliente).then(
      (response) => {
        this.setState({
          consultandoReservas: false,
          reservasProduto: (response && response.data) || [],
          reservasCarregadas: true,
          mostrarReservas: true,
        });
      },
      (error) => {
        let message =
          _.get(error, 'response.data') ||
          'Erro ao consultar pedidos que reservam este produto.';

        if (message && typeof message !== 'string') {
          message =
            _.get(message, 'message') ||
            _.get(message, 'error') ||
            'Erro ao consultar pedidos que reservam este produto.';
        }

        this.setState({
          consultandoReservas: false,
          reservasProduto: [],
          reservasCarregadas: true,
          mostrarReservas: true,
        });

        this.props.info({ message });
      },
    );
  };

  getReservaKey = (reserva) => {
    return (reserva && (reserva.pedidoId || reserva.numeroPedido)) || '';
  };

  atualizarDetalheReserva = (reserva, alteracoes) => {
    const key = this.getReservaKey(reserva);

    this.setState((state) => ({
      detalhesReservas: {
        ...state.detalhesReservas,
        [key]: {
          ...(state.detalhesReservas[key] || {}),
          ...alteracoes,
        },
      },
    }));
  };

  toggleDetalheReserva = (reserva) => {
    const key = this.getReservaKey(reserva);
    const detalhe = this.state.detalhesReservas[key];

    if (!reserva || !reserva.pedidoId) {
      return;
    }

    if (detalhe && detalhe.aberto) {
      this.atualizarDetalheReserva(reserva, { aberto: false });
      return;
    }

    if (detalhe && detalhe.pedido) {
      this.atualizarDetalheReserva(reserva, { aberto: true });
      return;
    }

    this.atualizarDetalheReserva(reserva, {
      aberto: true,
      carregando: true,
      erro: null,
    });

    pedidosService.doGet(reserva.pedidoId).then(
      (response) => {
        const dadosPedido = (response && response.data) || {};
        this.atualizarDetalheReserva(reserva, {
          carregando: false,
          pedido: {
            ...dadosPedido,
            id: dadosPedido.id || dadosPedido._id || reserva.pedidoId,
          },
        });
      },
      (error) => {
        let message =
          _.get(error, 'response.data') ||
          'Erro ao carregar os dados completos do pedido.';

        if (message && typeof message !== 'string') {
          message =
            _.get(message, 'message') ||
            _.get(message, 'error') ||
            'Erro ao carregar os dados completos do pedido.';
        }

        this.atualizarDetalheReserva(reserva, {
          carregando: false,
          erro: message,
        });
      },
    );
  };

  itemEhDoProdutoSelecionado = (item) => {
    const produtoSelecionado = this.props.produto || {};
    const produtoItem = (item && item.produto) || {};

    return (
      (produtoSelecionado.codigoProduto &&
        produtoSelecionado.codigoProduto === produtoItem.codigoProduto) ||
      (produtoSelecionado.codigoOmni &&
        String(produtoSelecionado.codigoOmni) ===
          String(produtoItem.codigoOmni))
    );
  };

  quantidadeReservadaNoPedido = (pedido) => {
    return _.sumBy((pedido && pedido.itens) || [], (item) =>
      this.itemEhDoProdutoSelecionado(item) && item.quantidade
        ? Number(item.quantidade)
        : 0,
    );
  };

  consolidarItensPedido = (itens) => {
    const itensConsolidados = [];
    const indicesPorProduto = {};

    _.forEach(itens || [], (item, indexItem) => {
      const produto = (item && item.produto) || {};
      const chaveProduto =
        produto.codigoProduto ||
        produto.codigoOmni ||
        `produto-sem-codigo-${indexItem}`;
      const indiceExistente = indicesPorProduto[chaveProduto];

      if (indiceExistente === undefined) {
        indicesPorProduto[chaveProduto] = itensConsolidados.length;
        itensConsolidados.push({
          ...item,
          quantidade: Number(item && item.quantidade) || 0,
          observacoes: item && item.observacoes,
        });
        return;
      }

      const itemConsolidado = itensConsolidados[indiceExistente];
      itemConsolidado.quantidade += Number(item && item.quantidade) || 0;

      const loteExistente = itemConsolidado.observacoes || '-';
      const loteAtual = (item && item.observacoes) || '-';
      if (loteExistente !== loteAtual) {
        itemConsolidado.observacoes = 'Vários';
      }
    });

    return itensConsolidados;
  };

  pedidoTemporario = (pedido, reserva) => {
    const numeroPedido = pedido && pedido.numeroPedido;

    if (numeroPedido) {
      return String(numeroPedido).indexOf('TMP-') === 0;
    }

    return Boolean(reserva && reserva.pedidoTemporario);
  };

  getQuantidadeEdicao = (reserva, quantidadeAtual) => {
    const key = this.getReservaKey(reserva);
    const valor = this.state.quantidadesEdicao[key];
    return valor === undefined ? quantidadeAtual : valor;
  };

  alterarQuantidadeEdicao = (reserva, quantidadeAtual, value) => {
    const quantidade = this.normalizarQuantidade(value);
    const key = this.getReservaKey(reserva);

    if (
      !this.podeAjustarItemIntegrado() &&
      quantidade !== null &&
      quantidade > quantidadeAtual
    ) {
      this.props.info({
        message: 'A nova quantidade deve ser menor que a quantidade atual.',
      });
      return;
    }

    this.setState((state) => ({
      quantidadesEdicao: {
        ...state.quantidadesEdicao,
        [key]: quantidade,
      },
    }));
  };

  extrairMensagemErro = (error, fallback) => {
    let message = _.get(error, 'response.data') || fallback;

    if (message && typeof message !== 'string') {
      message =
        _.get(message, 'message') || _.get(message, 'error') || fallback;
    }

    return message;
  };

  salvarQuantidadeItemIntegrado = (reserva, pedido, quantidadeNova) => {
    const pedidoId = pedido && (pedido.id || pedido._id || reserva.pedidoId);
    const itensDoProduto = _.filter(pedido && pedido.itens, (item) =>
      this.itemEhDoProdutoSelecionado(item),
    );

    if (!pedidoId) {
      this.props.info({
        message: 'Não foi possível identificar o pedido para atualização.',
      });
      return;
    }

    if (itensDoProduto.length !== 1) {
      this.props.info({
        message:
          'Não foi possível identificar uma única linha deste produto no pedido. Abra o pedido para realizar o ajuste.',
      });
      return;
    }

    const item = itensDoProduto[0];
    const itemIndex = (pedido.itens || []).indexOf(item);
    const quantidadeAtualItem = Number(item && item.quantidade);
    const produto = (item && item.produto) || {};
    const codigoProduto = produto.codigoProduto || produto.codigoOmni;
    const key = this.getReservaKey(reserva);

    if (!Number.isFinite(quantidadeAtualItem) || !codigoProduto) {
      this.props.info({
        message: 'O item não possui dados válidos para atualização.',
      });
      return;
    }

    this.setState((state) => ({
      salvandoReservas: {
        ...state.salvandoReservas,
        [key]: true,
      },
    }));

    pedidosService
      .ajustarItemQuantidade(pedidoId, {
        itemIndex,
        codigoProduto: String(codigoProduto),
        quantidadeAtual: quantidadeAtualItem,
        quantidade: quantidadeNova,
      })
      .then(
        (response) => {
          const dadosResposta = (response && response.data) || {};
          const pedidoSalvo = {
            ...dadosResposta,
            id: dadosResposta.id || dadosResposta._id || pedidoId,
          };

          this.atualizarDetalheReserva(reserva, {
            pedido: pedidoSalvo,
            salvo: true,
          });
          this.setState((state) => ({
            quantidadesEdicao: {
              ...state.quantidadesEdicao,
              [key]: undefined,
            },
            salvandoReservas: {
              ...state.salvandoReservas,
              [key]: false,
            },
          }));
          this.props.info({
            message:
              quantidadeNova === 0
                ? 'Item excluído do Omie e do pedido local.'
                : 'Quantidade do item atualizada no Omie e no pedido local.',
          });
          this.atualizarEstoqueDepoisDaAlteracao();
          this.carregarReservasProduto();
        },
        (error) => {
          this.setState((state) => ({
            salvandoReservas: {
              ...state.salvandoReservas,
              [key]: false,
            },
          }));
          this.props.info({
            message: this.extrairMensagemErro(
              error,
              'Não foi possível atualizar a quantidade no Omie.',
            ),
          });
        },
      );
  };

  salvarQuantidadeReserva = (reserva, pedido) => {
    const quantidadeAtual = this.quantidadeReservadaNoPedido(pedido);
    const quantidadeNova = this.getQuantidadeEdicao(reserva, quantidadeAtual);
    const sudo = this.podeAjustarItemIntegrado();
    const temporario = this.pedidoTemporario(pedido, reserva);

    if (!temporario && !sudo) {
      return;
    }

    const pedidoId = pedido && (pedido.id || pedido._id || reserva.pedidoId);

    if (!pedidoId) {
      this.props.info({
        message: 'Não foi possível identificar o pedido para atualização.',
      });
      return;
    }

    if (
      quantidadeNova === null ||
      quantidadeNova === undefined ||
      isNaN(Number(quantidadeNova))
    ) {
      this.props.info({ message: 'Informe uma quantidade válida.' });
      return;
    }

    if (!sudo && Number(quantidadeNova) >= quantidadeAtual) {
      this.props.info({
        message: 'A nova quantidade deve ser menor que a quantidade atual.',
      });
      return;
    }

    if (sudo && !temporario) {
      this.salvarQuantidadeItemIntegrado(
        reserva,
        pedido,
        Number(quantidadeNova),
      );
      return;
    }

    const itensDoProduto = _.filter(pedido.itens || [], (item) =>
      this.itemEhDoProdutoSelecionado(item),
    );

    if (itensDoProduto.length === 0) {
      this.props.info({ message: 'O produto não foi localizado no pedido.' });
      return;
    }

    if (
      Number(quantidadeNova) === 0 &&
      (pedido.itens || []).length === itensDoProduto.length
    ) {
      this.props.info({
        message: 'O pedido precisa manter pelo menos um produto.',
      });
      return;
    }

    const key = this.getReservaKey(reserva);
    const itensAtualizados = [];
    let produtoAplicado = false;

    _.forEach(pedido.itens || [], (item) => {
      if (!this.itemEhDoProdutoSelecionado(item)) {
        itensAtualizados.push(item);
        return;
      }

      if (!produtoAplicado && Number(quantidadeNova) > 0) {
        itensAtualizados.push({
          ...item,
          quantidade: quantidadeNova,
        });
        produtoAplicado = true;
      }
    });

    const pedidoAtualizado = {
      ...pedido,
      id: pedidoId,
      itens: itensAtualizados,
    };

    this.setState((state) => ({
      salvandoReservas: {
        ...state.salvandoReservas,
        [key]: true,
      },
    }));

    pedidosService.criar(pedidoAtualizado).then(
      (response) => {
        const dadosResposta = (response && response.data) || {};
        const pedidoSalvo = {
          ...dadosResposta,
          id: dadosResposta.id || dadosResposta._id || pedidoId,
        };
        this.atualizarDetalheReserva(reserva, {
          pedido: pedidoSalvo,
          salvo: true,
        });
        this.setState((state) => ({
          quantidadesEdicao: {
            ...state.quantidadesEdicao,
            [key]: undefined,
          },
          salvandoReservas: {
            ...state.salvandoReservas,
            [key]: false,
          },
        }));
        this.props.info({
          message:
            'Quantidade do pedido temporário atualizada e reserva liberada.',
        });
        this.atualizarEstoqueDepoisDaAlteracao();
        this.carregarReservasProduto();
      },
      (error) => {
        this.setState((state) => ({
          salvandoReservas: {
            ...state.salvandoReservas,
            [key]: false,
          },
        }));
        this.props.info({
          message: this.extrairMensagemErro(
            error,
            'Não foi possível atualizar a quantidade e liberar a reserva.',
          ),
        });
      },
    );
  };

  atualizarEstoqueDepoisDaAlteracao = () => {
    if (!this.props.atualizarEstoque) {
      return;
    }

    const resultado = this.props.atualizarEstoque(this.props.produto);

    if (resultado && typeof resultado.catch === 'function') {
      resultado.catch((error) => {
        this.props.info({
          message: this.extrairMensagemErro(
            error,
            'Pedido atualizado, mas não foi possível atualizar o saldo exibido.',
          ),
        });
      });
    }
  };

  formatarSituacaoReserva = (situacaoReserva) => {
    if (situacaoReserva === 'TEMPORARIO') {
      return 'Temporario';
    }

    if (situacaoReserva === 'INTEGRADO') {
      return 'Integrado';
    }

    if (situacaoReserva === 'INCONSISTENTE') {
      return 'Inconsistente';
    }

    if (situacaoReserva === 'ATIVA') {
      return 'Ativa';
    }

    return situacaoReserva || '-';
  };

  renderDetalheReserva = (reserva) => {
    const key = this.getReservaKey(reserva);
    const detalhe = this.state.detalhesReservas[key] || {};

    if (!detalhe.aberto) {
      return null;
    }

    if (detalhe.carregando) {
      return (
        <tr className="reserva-detalhe-row">
          <td colSpan="6" className="text-muted">
            Carregando os dados completos do pedido...
          </td>
        </tr>
      );
    }

    if (detalhe.erro) {
      return (
        <tr className="reserva-detalhe-row">
          <td colSpan="6" className="text-danger">
            {detalhe.erro}
          </td>
        </tr>
      );
    }

    const pedido = detalhe.pedido || {};
    const itens = this.consolidarItensPedido(pedido.itens || []);
    const quantidadeAtual = this.quantidadeReservadaNoPedido(pedido);
    const quantidadeEditada = this.getQuantidadeEdicao(
      reserva,
      quantidadeAtual,
    );
    const temporario = this.pedidoTemporario(pedido, reserva);
    const sudo = this.podeAjustarItemIntegrado();
    const salvando = Boolean(this.state.salvandoReservas[key]);
    const podeSalvar =
      (temporario || sudo) &&
      quantidadeEditada !== null &&
      quantidadeEditada !== undefined &&
      Number(quantidadeEditada) >= 0 &&
      (sudo
        ? Number(quantidadeEditada) >= 0
        : Number(quantidadeEditada) < quantidadeAtual) &&
      !salvando;

    return (
      <tr className="reserva-detalhe-row">
        <td colSpan="6">
          <div className="reserva-detalhe">
            <div className="reserva-detalhe-grid">
              <div>
                <span className="reserva-detalhe-label">Pedido</span>
                <strong>
                  {pedido.numeroPedido || reserva.numeroPedido || '-'}
                </strong>
              </div>
              <div>
                <span className="reserva-detalhe-label">Pedido do cliente</span>
                <span>{pedido.numeroPedidoCliente || '-'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Data</span>
                <span>
                  {pedido.createdAt
                    ? moment(pedido.createdAt).format('DD/MM/YYYY HH:mm')
                    : '-'}
                </span>
              </div>
              <div>
                <span className="reserva-detalhe-label">
                  Unidade solicitante
                </span>
                <span>
                  {pedido.pontoAtendimentoNome ||
                    reserva.unidadeSolicitante ||
                    '-'}
                </span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Status</span>
                <span>{pedido.statusInterno || pedido.status || '-'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Status WMS</span>
                <span>{pedido.statusAlcis || '-'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Tipo</span>
                <span>{pedido.tipoPedido || '-'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Grupo</span>
                <span>{pedido.grupoPedido || '-'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Cliente</span>
                <span>
                  {(pedido.cliente &&
                    (pedido.cliente.nomeFantasia ||
                      pedido.cliente.razaoSocial)) ||
                    '-'}
                </span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Prioridade</span>
                <span>{pedido.urgente ? 'Urgente' : 'Normal'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Transportadora</span>
                <span>{pedido.transportadora || '-'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Nota fiscal</span>
                <span>{pedido.numeroNotaFiscal || '-'}</span>
              </div>
              <div>
                <span className="reserva-detalhe-label">Concluído</span>
                <span>{pedido.concluido ? 'Sim' : 'Não'}</span>
              </div>
              {pedido.nomePaciente && (
                <div>
                  <span className="reserva-detalhe-label">Paciente</span>
                  <span>{pedido.nomePaciente}</span>
                </div>
              )}
              {pedido.cpfPaciente && (
                <div>
                  <span className="reserva-detalhe-label">CPF do paciente</span>
                  <span>{pedido.cpfPaciente}</span>
                </div>
              )}
              <div>
                <span className="reserva-detalhe-label">
                  Situação da reserva
                </span>
                <span>
                  {this.formatarSituacaoReserva(reserva.situacaoReserva)}
                </span>
              </div>
            </div>

            {pedido.observacoes && (
              <div className="reserva-detalhe-observacoes">
                <span className="reserva-detalhe-label">Observações</span>
                <span>{pedido.observacoes}</span>
              </div>
            )}

            <div className="reserva-detalhe-itens">
              <span className="reserva-detalhe-label">Itens do pedido</span>
              <table className="table table-sm mb-0">
                <thead>
                  <tr>
                    <th>Produto</th>
                    <th>Descrição</th>
                    <th>Quantidade</th>
                    <th>Lote</th>
                  </tr>
                </thead>
                <tbody>
                  {itens.map((item, indexItem) => {
                    const produto = item.produto || {};
                    const itemSelecionado = this.itemEhDoProdutoSelecionado(
                      item,
                    );

                    return (
                      <tr
                        key={`${produto.codigoProduto ||
                          'produto'}-${indexItem}`}
                        className={
                          itemSelecionado ? 'reserva-item-selecionado' : ''
                        }
                      >
                        <td>
                          {produto.codigoProduto || produto.codigoOmni || '-'}
                        </td>
                        <td>
                          {produto.descricao || produto.descricaoProduto || '-'}
                        </td>
                        <td>{item.quantidade || 0}</td>
                        <td>{item.observacoes || '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {temporario || sudo ? (
              <div className="reserva-detalhe-edicao">
                <div>
                  <strong>
                    {sudo && !temporario
                      ? 'Alterar quantidade deste item integrado'
                      : 'Alterar quantidade reservada deste produto'}
                  </strong>
                  <small className="d-block text-muted">
                    {sudo && !temporario
                      ? 'A alteração será sincronizada com o Omie. Ao informar zero, o item será excluído.'
                      : `Informe uma quantidade menor que ${quantidadeAtual}. Ao informar zero, o produto será removido e a reserva será liberada.`}
                  </small>
                </div>
                <div className="reserva-detalhe-edicao-controles">
                  <input
                    type="number"
                    min="0"
                    max={sudo ? undefined : quantidadeAtual}
                    step={this.isUnidadePeso() ? '0.001' : '1'}
                    className="form-control"
                    value={quantidadeEditada === null ? '' : quantidadeEditada}
                    disabled={salvando}
                    onChange={(e) =>
                      this.alterarQuantidadeEdicao(
                        reserva,
                        quantidadeAtual,
                        e.target.value,
                      )
                    }
                  />
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!podeSalvar}
                    onClick={() =>
                      this.salvarQuantidadeReserva(reserva, pedido)
                    }
                  >
                    {salvando ? 'Salvando...' : 'Salvar quantidade'}
                  </button>
                </div>
              </div>
            ) : (
              <div className="alert alert-info mb-0">
                Este pedido já está integrado. A quantidade não pode ser
                alterada nesta tela. Para solicitar alteração, entre em contato
                com o pessoal da Biotech e informe o número do pedido e do item.
              </div>
            )}
          </div>
        </td>
      </tr>
    );
  };

  normalizarQuantidade = (value) => {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const permiteDecimal = this.isUnidadePeso();
    let valor = String(value).replace(',', '.');

    if (!permiteDecimal) {
      valor = valor.replace(/[^\d]/g, '');

      if (valor === '') {
        return null;
      }

      const inteiro = parseInt(valor, 10);
      return isNaN(inteiro) ? null : inteiro;
    }

    valor = valor.replace(/[^\d.]/g, '');

    const partes = valor.split('.');
    if (partes.length > 2) {
      valor = partes[0] + '.' + partes.slice(1).join('');
    }

    const decimal = parseFloat(valor);
    return isNaN(decimal) ? null : decimal;
  };

  onChange = (estoque, quantidade) => {
    quantidade = this.normalizarQuantidade(quantidade);

    let produtos = _.cloneDeep(this.state.produtos);
    let estoqueProduto = this.props.estoque;
    _.map(estoqueProduto, (e) => {
      let produto = _.filter(produtos, {
        dataDeValidade: e.dataDeValidade,
        observacoes: e.lote,
      });
      if (
        moment(e.dataDeValidade).isBefore(moment(estoque.dataDeValidade)) &&
        (produto.length === 0 || e.quantidadeDisponivel > produto[0].quantidade)
      ) {
        this.props.info({ message: 'Lote não segue a regra FEFO' });
      }
    });
    let existeProduto = false;
    _.map(produtos, (produto) => {
      if (
        produto.observacoes === estoque.lote &&
        produto.dataDeValidade === estoque.dataDeValidade
      ) {
        produto.quantidade = quantidade;

        existeProduto = true;
      }
    });
    if (!existeProduto) {
      produtos.push({
        quantidade,
        observacoes: estoque.lote,
        dataDeValidade: estoque.dataDeValidade,
      });
    }

    this.setState({ produtos });
  };
  toggleModal = () => {
    this.props.toggleModal();
  };

  salvarEstoque = () => {
    // this.props.selectEstoque(this.state.produtos);
    // this.setState({ produtos: [] });

    if (this.props.ocultarLoteValidadeProduto) {
      const totalDesejado = this.state.quantidadeTotal;
      let quantidadeRestante = totalDesejado;
      const produtos = [];

      const estoquesOrdenados = _.sortBy(this.props.estoque, (e) =>
        moment(e.dataDeValidade),
      );

      for (let estoque of estoquesOrdenados) {
        if (quantidadeRestante <= 0) break;

        const usar = Math.min(estoque.quantidadeDisponivel, quantidadeRestante);
        quantidadeRestante -= usar;

        produtos.push({
          quantidade: usar,
          observacoes: estoque.lote,
          lote: estoque.lote,
          dataDeValidade: estoque.dataDeValidade,
        });
      }

      if (quantidadeRestante > 0) {
        this.props.info({
          message: 'Quantidade solicitada excede o estoque disponível.',
        });
        return;
      }

      this.props.selectEstoque(produtos);
      this.setState({ produtos: [], quantidadeTotal: null });
    } else {
      this.props.selectEstoque(this.state.produtos);
      this.setState({ produtos: [] });
    }
  };

  render() {
    const { index, estoque, ocultarLoteValidadeProduto } = this.props;
    const produtoSelecionado = this.props.produto || {};
    const codigoProduto =
      produtoSelecionado.codigoProduto || produtoSelecionado.codigoOmni || '';
    const descricaoProduto =
      produtoSelecionado.descricao || produtoSelecionado.descricaoProduto || '';
    const produtoExibicao =
      (codigoProduto && descricaoProduto
        ? `${codigoProduto} - ${descricaoProduto}`
        : produtoSelecionado.label || codigoProduto || descricaoProduto) || '-';
    const possuiPontoAtendimento = this.props.possuiPontoAtendimento === true;
    const totalDisponivel = _.sumBy(estoque, 'quantidadeDisponivel');
    const totalReservado = _.sumBy(estoque, (item) =>
      Number(item && item.quantidadeReservada ? item.quantidadeReservada : 0),
    );
    const podeConsultarReservas = this.podeConsultarReservas(totalReservado);

    return (
      <Modal
        size="lg"
        isOpen={this.props.isModalVisible}
        toggle={this.toggleModal}
        className={'modal-pedido'}
      >
        <div className="modal-header no-border justify-content-left">
          {/* <img src={iconChecklist} className="float-left mr-3" alt="icone"></img> */}
          <div className="mt-2 w-100">
            <div className="w-100 d-flex justify-content-end ">
              <button
                type="submit"
                className="btn btn-light mx-1"
                disabled={false}
                onClick={this.props.onCancel}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary mx-1"
                disabled={false}
                onClick={this.salvarEstoque}
              >
                Salvar
              </button>
            </div>
            <div className="p-2 mb-3 bg-light">
              <label className="txtCinza mb-1 d-block">
                Produto selecionado
              </label>
              <strong>{produtoExibicao}</strong>
            </div>
            <p>
              <b>
                {possuiPontoAtendimento
                  ? 'Selecione abaixo a quantidade para solicitar o pedido:'
                  : 'Selecione abaixo os Lotes e quantidades para solicitar o pedido:'}
              </b>
            </p>
          </div>
          {/* <img src={iconFechar} className="pointer ml-auto" onClick={this.toggleModal} alt="fechar"></img> */}
        </div>

        <ModalBody>
          <div className="col d-flex flex-column corpo-modal">
            {/* bloco form Visualização */}

            {/* Serviços e acessórios */}
            <label className="txtCinza">Estoque</label>
            {/* Bloco form Visualização */}

            {/* Fim  bloco form Visualização */}
            {/* Inicio Botão add */}
            <div className="text-right pt-1 underline">
              {' '}
              <table className="col-12 table modal-pedido-estoque-table">
                <thead>
                  <tr>
                    <th>Quantidade Disponivel</th>
                    <th>Quantidade Reservada</th>
                    {!ocultarLoteValidadeProduto && (
                      <>
                        <th>Lote</th>
                        <th>Data de Validade</th>
                      </>
                    )}
                    <th>Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  {!ocultarLoteValidadeProduto ? (
                    estoque.map((estoque, indexEstoque) => {
                      if (!this.state.viewMode) {
                        let produto = _.find(this.state.produtos, {
                          observacoes: estoque.lote,
                          dataDeValidade: estoque.dataDeValidade,
                        });
                        return (
                          <tr
                            key={`${estoque.lote ||
                              'sem-lote'}-${indexEstoque}`}
                          >
                            <td>{estoque.quantidadeDisponivel}</td>
                            <td>{estoque.quantidadeReservada || 0}</td>
                            <td>{estoque.lote}</td>
                            <td>
                              {estoque.dataDeValidade &&
                                moment(estoque.dataDeValidade).format(
                                  'DD/MM/YYYY',
                                )}
                            </td>
                            <td>
                              <div className="form-group col-12 col-lg-12 ">
                                <input
                                  type="number"
                                  step={this.isUnidadePeso() ? '0.001' : '1'}
                                  min="0"
                                  className="form-control"
                                  name={`itens[${index}].produto.estoque[${indexEstoque}].quantidade`}
                                  placeholder={
                                    this.isUnidadePeso()
                                      ? 'Digite a quantidade. Ex: 0,290'
                                      : 'Digite a quantidade inteira'
                                  }
                                  value={produto && produto.quantidade}
                                  onChange={(e) => {
                                    const quantidade = this.normalizarQuantidade(
                                      e.target.value,
                                    );
                                    this.onChange(estoque, quantidade);
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      } else {
                        if (estoque.quantidade) {
                          return (
                            <tr
                              key={`${estoque.lote ||
                                'sem-lote'}-view-${indexEstoque}`}
                            >
                              <td>{estoque.lote}</td>
                              {/*<td>{estoque.dataDeValidade&&moment(estoque.dataDeValidade).format('DD/MM/YYYY')}</td>*/}
                              <td>{estoque.quantidade}</td>
                            </tr>
                          );
                        }
                      }

                      return null;
                    })
                  ) : (
                    <tr>
                      <td>{totalDisponivel}</td>
                      <td>{totalReservado}</td>
                      {/* <td colSpan={2}>-</td> */}
                      <td>
                        <input
                          type="number"
                          step={this.isUnidadePeso() ? '0.001' : '1'}
                          min="0"
                          className="form-control"
                          name="quantidadeUnica"
                          placeholder={
                            this.isUnidadePeso()
                              ? 'Digite a quantidade. Ex: 0,290'
                              : 'Digite a quantidade inteira'
                          }
                          value={this.state.quantidadeTotal || ''}
                          onChange={(e) => {
                            const val = this.normalizarQuantidade(
                              e.target.value,
                            );

                            this.setState({
                              quantidadeTotal: val,
                            });
                          }}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {podeConsultarReservas && (
              <div className="mt-3">
                <div className="d-flex justify-content-between align-items-center">
                  <label className="txtCinza mb-0">
                    Pedidos que estão consumindo esta reserva
                  </label>
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    disabled={this.state.consultandoReservas}
                    onClick={this.toggleReservasProduto}
                  >
                    {this.state.mostrarReservas
                      ? 'Ocultar pedidos reservados'
                      : 'Ver pedidos reservados'}
                  </button>
                </div>

                {this.state.consultandoReservas && (
                  <small className="text-muted">
                    Consultando pedidos reservados...
                  </small>
                )}

                {this.state.mostrarReservas && !this.state.consultandoReservas && (
                  <div className="table-responsive modal-pedido-reservas-wrap">
                    <table className="table table-sm modal-pedido-reservas-table">
                      <thead>
                        <tr>
                          <th className="reserva-col-pedido">Nº Pedido</th>
                          <th className="reserva-col-data">Data</th>
                          <th className="reserva-col-unidade">
                            Unidade Solicitante
                          </th>
                          <th className="reserva-col-quantidade">
                            Qtd. Reservada
                          </th>
                          <th className="reserva-col-status">Status</th>
                          <th className="reserva-col-situacao">
                            Situação da Reserva
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.reservasProduto.length === 0 && (
                          <tr>
                            <td colSpan="6" className="text-center text-muted">
                              Nenhum pedido com reserva ativa foi localizado
                              para este produto.
                            </td>
                          </tr>
                        )}
                        {this.state.reservasProduto.map((reserva) => {
                          const detalhe = this.state.detalhesReservas[
                            this.getReservaKey(reserva)
                          ];

                          return (
                            <React.Fragment key={this.getReservaKey(reserva)}>
                              <tr
                                className="reserva-row"
                                onClick={() =>
                                  this.toggleDetalheReserva(reserva)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleDetalheReserva(reserva);
                                  }
                                }}
                                role="button"
                                tabIndex="0"
                                aria-expanded={Boolean(
                                  detalhe && detalhe.aberto,
                                )}
                              >
                                <td className="reserva-col-pedido">
                                  <span className="reserva-pedido-numero">
                                    {reserva.numeroPedido}
                                  </span>
                                  {reserva.pedidoTemporario && (
                                    <span className="reserva-pedido-tag">
                                      TMP
                                    </span>
                                  )}
                                </td>
                                <td className="reserva-col-data">
                                  {reserva.dataPedido
                                    ? moment(reserva.dataPedido).format(
                                        'DD/MM/YYYY HH:mm',
                                      )
                                    : '-'}
                                </td>
                                <td className="reserva-col-unidade">
                                  {reserva.unidadeSolicitante || '-'}
                                </td>
                                <td className="reserva-col-quantidade">
                                  {reserva.quantidadeReservada || 0}
                                </td>
                                <td className="reserva-col-status">
                                  {reserva.statusInterno ||
                                    reserva.status ||
                                    '-'}
                                </td>
                                <td className="reserva-col-situacao">
                                  {this.formatarSituacaoReserva(
                                    reserva.situacaoReserva,
                                  )}
                                </td>
                              </tr>
                              {this.renderDetalheReserva(reserva)}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default connect(
  null,
  null,
)(withRouter(CadastroPedidoModal));
